/**
 * Used to determine the source (the page) that the authentication was made from
 */
export enum AuthSource {
   QuotesPage = 'quotes',
   InsuranceForms = 'forms'
}
